import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'v2m-blog-v240',
  templateUrl: './blog-v240.component.html',
  styleUrls: ['./blog-v240.component.scss']
})
export class BlogV240Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
